import { httpClient } from '@/services/http/httpClient'

type Params = {
  areaId: string
  usersIds: string[]
}

export async function changeArea({ areaId, usersIds }: Params) {
  await httpClient.post('/users/assign-area', {
    areaId,
    usersIds,
  })
}
